const LoanSettings = () => import("./views/LoanSettings.vue");
const AllLoanRequest = () => import("./views/AllLoanRequest.vue");
const LoanRequestForm = () => import("./views/LoanRequestForm.vue");
const AllLoanApproval = () => import("./views/AllLoanApproval.vue");
const AllLoansDisbursed = () => import("./views/AllLoansDisbursed.vue");
const LoanDisbursementForm = () => import("./views/LoanDisbursementForm.vue");
const AllLoanRefund = () => import("./views/AllLoanRefund.vue");
const LoanRefundForm = () => import("./views/LoanRefundForm.vue");
const LoanTypeSettings = () => import("./views/LoanTypeSettings.vue");
const LoanTypeCreate = () => import("./views/LoanTypeCreate.vue");
const LoanTypeView = () => import("./views/LoanTypeView.vue");
const LoanCapForm = () => import("./views/LoanCapForm.vue");
const LoanApprovalSettings = () => import("./views/LoanApprovalSettings.vue");
const LoanApprovalSettingsForm = () =>
  import("./views/LoanApprovalSettingsForm.vue");

const AllApprovers = () =>
  import("@/components/general/approvals/AllApprovers.vue");
const AssignEmployeesAsApprovers = () =>
  import("@/components/general/approvals/AssignEmployeeToApprover.vue");
const ViewApprovers = () =>
  import("@/components/general/approvals/ViewApprovers.vue");
const CreateApprover = () =>
  import("@/components/general/approvals/CreateApprovers.vue");

import approverProps from "@/components/general/approvals/ApproverProps.js";
const { loanRequest } = approverProps;
export default [
  {
    path: "loan-request",
    redirect: "/admin/payroll/loan/loan-request/view-all",
  },
  {
    path: "loan-request/view-all",
    name: "view-all-loan-requests",
    component: AllLoanRequest,
  },
  {
    path: "loan-request/create",
    name: "create-loan-request",
    component: LoanRequestForm,
  },
  {
    path: "loan-request/edit/:id",
    name: "edit-loan-request",
    component: LoanRequestForm,
  },
  {
    path: "loan-approval",
    redirect: "/admin/payroll/loan/loan-approval/view-all",
  },
  {
    path: "loan-approval/view-all",
    component: AllLoanApproval,
  },
  {
    path: "loan-disbursement",
    redirect: "/admin/payroll/loan/loan-disbursement/view-all",
  },
  {
    name: "view-all-loan-disbursement",
    path: "loan-disbursement/view-all",
    component: AllLoansDisbursed,
  },
  {
    name: "create-loan-disbursement",
    path: "loan-disbursement/create",
    component: LoanDisbursementForm,
  },
  {
    path: "loan-refund",
    redirect: "/admin/payroll/loan/loan-refund/view-all",
  },
  {
    name: "view-all-loan-refund",
    path: "loan-refund/view-all",
    component: AllLoanRefund,
  },
  {
    name: "create-loan-refund",
    path: "loan-refund/create",
    component: LoanRefundForm,
  },
  {
    name: "edit-loan-refund",
    path: "loan-refund/edit/:id",
    component: LoanRefundForm,
  },
  {
    path: "settings",
    component: LoanSettings,
  },
  {
    path: "settings/loan-type-settings",
    component: LoanTypeSettings,
  },
  {
    path: "settings/loan-type/create",
    component: LoanTypeCreate,
  },
  {
    path: "settings/loan-type/view/:id",
    component: LoanTypeView,
  },
  {
    path: "settings/loan-type/edit/:id",
    component: LoanTypeCreate,
  },
  {
    path: "settings/loan-cap/form",
    component: LoanCapForm,
  },
  {
    path: "settings/loan-approval/view-all",
    component: LoanApprovalSettings,
  },
  {
    path: "settings/loan-approval/create",
    component: LoanApprovalSettingsForm,
  },
  {
    path: "settings/loan-approval/edit/:id",
    component: LoanApprovalSettingsForm,
  },
  {
    path: "loan-refund/create",
    component: LoanRefundForm,
  },
  {
    path: "settings",
    component: LoanSettings,
  },
  {
    path: "settings/approvers",
    component: AllApprovers,
    props: loanRequest,
  },
  {
    path: "settings/approvers/assign/:id",
    component: AssignEmployeesAsApprovers,
    props: loanRequest,
  },
  {
    path: "settings/approvers/edit/:id",
    component: CreateApprover,
    props: loanRequest,
  },
  {
    path: "settings/approvers/view/:id",
    component: ViewApprovers,
    props: loanRequest,
  },
  {
    path: "settings/approvers/create",
    component: CreateApprover,
    props: loanRequest,
  },
];
